import { call, put, take, actionChannel } from "redux-saga/effects";

import { POST, GET, PUT, DELETE } from "../types/request.types";
import { requestHandler } from "./fetcher.saga";
import { buffers } from "redux-saga";
import {
  PRE_ADD_USER_ADDRESS,
  ADD_USER_ADDRESS,
  REQUEST_ADD_USER_ADDRESS,
  REQUEST_ADD_USER_ADDRESS_FINISHED,
  PRE_GET_USER_DATA,
  REQUEST_GET_USER_DATA,
  REQUEST_GET_USER_DATA_FINISHED,
  GET_USER_DATA,
  REQUEST_UPDATE_USER_DATA,
  PRE_UPDATE_USER_DATA,
  REQUEST_UPDATE_USER_DATA_FINISHED,
  UPDATE_USER_DATA,
} from "../types/user.types";

//ADDING DELIVERY ADDRESS
export function* preAddUserAddress() {
  while (true) {
    const action = yield take(PRE_ADD_USER_ADDRESS);
    const deliveryAddress = action.payload;
    yield put({
      type: REQUEST_ADD_USER_ADDRESS,
      body: {
        deliveryAddress,
      },
    });

    yield take(REQUEST_ADD_USER_ADDRESS_FINISHED);
    yield put({
      type: ADD_USER_ADDRESS,
      response: deliveryAddress,
    });
  }
}

export function* watchAddUserAddress() {
  const requestChan = yield actionChannel(
    REQUEST_ADD_USER_ADDRESS,
    buffers.expanding()
  );
  while (true) {
    //const user_id = window.localStorage.getItem("USER_ID");
    const action = yield take(requestChan);

    const addData = yield call(
      requestHandler,
      PUT,
      `address/${window.localStorage.USER_ID}`,
      action.body.deliveryAddress
    );
    yield put({
      type: REQUEST_ADD_USER_ADDRESS_FINISHED,
      deliveryAddressAdded: addData,
    });
  }
}

//GET USER DATA
export function* preGetUserData() {
  while (true) {
    const action = yield take(PRE_GET_USER_DATA);
    const idUser = action.payload;
    yield put({
      type: REQUEST_GET_USER_DATA,
      body: {
        idUser,
      },
    });

    const getUserData = yield take(REQUEST_GET_USER_DATA_FINISHED);
    yield put({
      type: GET_USER_DATA,
      response: getUserData.response.data.result,
    });
  }
}

export function* watchGetUserData() {
  const requestChan = yield actionChannel(
    REQUEST_GET_USER_DATA,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);

    const getUser = yield call(
      requestHandler,
      GET,
      `user/${action.body.idUser}`
    );
    yield put({
      type: REQUEST_GET_USER_DATA_FINISHED,
      response: getUser,
    });
  }
}

//UPDATE USER DATA
export function* preUpdateUserData() {
  while (true) {
    const action = yield take(PRE_UPDATE_USER_DATA);
    const { userData, idUser } = action.payload;
    yield put({
      type: REQUEST_UPDATE_USER_DATA,
      body: {
        userData,
        idUser,
      },
    });

    yield take(REQUEST_UPDATE_USER_DATA_FINISHED);
    yield put({
      type: UPDATE_USER_DATA,
      response: userData,
    });
  }
}

export function* watchUpdateUserData() {
  const requestChan = yield actionChannel(
    REQUEST_UPDATE_USER_DATA,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);

    yield call(
      requestHandler,
      PUT,
      `user/${action.body.idUser}`,
      action.body.userData
    );
    yield put({
      type: REQUEST_UPDATE_USER_DATA_FINISHED,
    });
  }
}
